<template>
  <div>
    <el-form ref="form" :model="curInput" :rules="rules" label-width="100px">
      <el-form-item label="默认值" prop="default">
        <el-input type="textarea" v-model.trim="curInput.textarea.write_default" class="h-40 w-200"></el-input>
      </el-form-item>
    </el-form>
    <textlen-config :config="curInput.textarea" :limitMax="true" :maxCount="500"></textlen-config>
  </div>
</template>

<script>
  import textlenConfig from './textlenConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
      }
    },
    components: {
      textlenConfig
    }
  }
</script>


// WEBPACK FOOTER //
// textareaConfig.vue?64489afc